export default (entities) => ({
  getInvitedUser(token) {
    return entities.Invitation.find(token);
  },
});
